// src/api/skills.js

import { get, post, patch } from "@/lib/fetcher";

/**
 * Fetch all skills
 */
export async function getSkills() {
    return await get("/admin/skills");
}

/**
 * Create a new skill
 * @param {Object} data - { category, skill, starting_price, top_price, price_unit }
 */
export async function postSkill(data) {
    return await post("/admin/skills", data);
}

/**
 * Update an existing skill by ID
 * @param {string|number} id - the skill ID
 * @param {Object} data - updated skill data
 */
export async function patchSkill(id, data) {
    return await patch("/admin/skills", id, data);
}
